<template>
    <div class="item-menu-wrapper">
        <label :for="inputId" class="item-menu-label">
            {{ label }}
            <i
                v-if="tooltip"
                class="pi pi-question-circle"
                v-tooltip.top="{
                    value: tooltip,
                    autoHide: false,
                }"
            />
        </label>
        <slot :inputId="inputId" />
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    label: {
        type: String,
        required: true,
    },
    tooltip: {
        type: String,
        default: null,
    },
});

const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;
</script>

<style lang="scss" scoped>
.item-menu-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;

    .item-menu-label {
        display: flex;
        align-items: center;
        gap: 6px;
        padding-bottom: 4px;

        i {
            cursor: help;
        }
    }
}
</style>
